module.exports = __webpack_public_path__ + "img/usebusiness_icon.d2b78305.png";